// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Header */

.help-desk-messenger-header {
  position: relative;
  min-height: 75px;
  color: white;
  transition: height 160ms ease-out 0s;
  background: linear-gradient(135deg, rgb(36, 44, 52) 0%, rgb(20, 68, 95) 100%);
}
`, "",{"version":3,"sources":["webpack://./dist/src/components/layout/header/header.css"],"names":[],"mappings":";AACA,WAAW;;AAEX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,6EAA6E;AAC/E","sourcesContent":["\r\n/* Header */\r\n\r\n.help-desk-messenger-header {\r\n  position: relative;\r\n  min-height: 75px;\r\n  color: white;\r\n  transition: height 160ms ease-out 0s;\r\n  background: linear-gradient(135deg, rgb(36, 44, 52) 0%, rgb(20, 68, 95) 100%);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
